import { useQuery } from '@tanstack/react-query';
import { licensesManageService } from '../api/licensesManageService';

export function useLicenseActivityQuery(
  licenseId: string | undefined,
  skipCount: number,
  maxResultCount: number,
) {
  return useQuery({
    queryKey: ['manage-licenses', 'activity', licenseId, skipCount, maxResultCount],
    queryFn: () => licensesManageService.activityHistory(licenseId!, skipCount, maxResultCount),
    enabled: !!licenseId,
    staleTime: 10_000,
  });
}
